import React from 'react';
import { IonIcon } from '@ionic/react';
import { arrowBack, home, person } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebaseConfig';

const NavBar: React.FC = () => {
  const history = useHistory();
  const [user] = useAuthState(auth);

  const handleBack = () => {
    history.goBack();
  };

  const handleHome = () => {
    if (user && user.emailVerified) {
      history.push('/teacher-selection');
    } else {
      history.push('/home');
    }
  };

  const handleDashboard = () => {
    history.push('/dashboard');
  };

  return (
    <div className="fixed bottom-5 left-4 right-4 z-50">
      <div className="bg-[rgba(30,30,30,0.95)] backdrop-blur-lg rounded-[14px] h-16 shadow-lg">
        <div className="grid grid-cols-3 h-full">
          <button
            onClick={handleBack}
            className="flex items-center justify-center transition-transform duration-200 hover:scale-110"
          >
            <IonIcon 
              icon={arrowBack} 
              className="w-7 h-7 text-white/70 hover:text-white" 
            />
          </button>

          <button
            onClick={handleHome}
            className="flex items-center justify-center transition-transform duration-200 hover:scale-110"
          >
            <IonIcon 
              icon={home} 
              className="w-7 h-7 text-white/70 hover:text-white" 
            />
          </button>

          <button
            onClick={handleDashboard}
            className="flex items-center justify-center transition-transform duration-200 hover:scale-110"
          >
            <IonIcon 
              icon={person} 
              className="w-7 h-7 text-white/70 hover:text-white" 
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
